import { render, staticRenderFns } from "./EnvioInventarioTableComponent.vue?vue&type=template&id=55c4f67b&"
import script from "./EnvioInventarioTableComponent.vue?vue&type=script&lang=js&"
export * from "./EnvioInventarioTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports